import i18next from 'i18next';
import { locales } from 'configs/i18n';

/* ------------------------------------- English ------------------------------------- */
i18next.addResources(locales.EN, 'LOCATION_SELECTOR', {
  COUNTRY: 'Country',
  PROVINCE: 'Province/State',
  LOCALITY: 'Locality/City',
});

/* ------------------------------------- Spanish ------------------------------------- */
i18next.addResources(locales.ES, 'LOCATION_SELECTOR', {
  COUNTRY: 'País',
  PROVINCE: 'Provincia/Estado',
  LOCALITY: 'Localidad/Ciudad',
});

export default i18next;
